export default function GroupFarmsGroupSequencesComponents() {
    return (
        <div>
            <h1>Pagina en proceso :D</h1>
        </div>
    );
}
